import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/common/ico_play_blue.svg?url_encode")